import { motion } from "framer-motion";
import { ArrowRight, Monitor } from "lucide-react";

import { Button, Card, LinkButton, StatusPill } from "./ui";

export function DownloadPage() {
  return (
    <main className="relative min-h-screen overflow-hidden pt-16">
      <div className="download-bg absolute inset-0 z-0 bg-bg">
        <div className="absolute inset-0 bg-gt-grid opacity-45" />
        <div className="absolute inset-0 bg-bg/28" />
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-64 bg-gradient-to-b from-transparent to-bg" />
      </div>

      <section className="relative z-10 mx-auto grid min-h-[calc(100vh-4rem)] max-w-7xl items-center gap-10 px-6 py-24 lg:grid-cols-[1fr_0.74fr]">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45, ease: "easeOut" }}
        >
          <div className="mb-6 flex items-center gap-3">
            <div className="h-px w-10 bg-primary" />
            <span className="text-[11px] font-semibold uppercase tracking-[0.3em] text-primary">
              Windows Download
            </span>
          </div>
          <h1 className="mb-7 whitespace-nowrap font-display text-6xl font-bold uppercase leading-[0.9] text-text md:text-8xl">
            Get iBox
          </h1>
          <p className="max-w-2xl text-lg leading-relaxed text-muted md:text-xl">Download the iBox Desktop app to get started.</p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45, delay: 0.08, ease: "easeOut" }}
        >
          <Card interactive={false} className="p-0">
            <div className="border-b border-border p-6">
              <div className="mb-6 flex items-start justify-between gap-4">
                <div className="flex h-12 w-12 items-center justify-center rounded-lg border border-border bg-bg text-primary">
                  <Monitor size={22} strokeWidth={1.6} />
                </div>
                <StatusPill status="success" label="WINDOWS" />
              </div>

              <h2 className="font-display text-3xl font-bold uppercase leading-none text-text">iBox Setup</h2>
              <p className="mt-3 text-sm leading-relaxed text-muted">Latest Windows installer for the iBox desktop app.</p>
            </div>

            <div className="flex flex-col gap-3 p-6 sm:flex-row">
              <Button className="flex-1" type="button">
                Download
              </Button>
              <LinkButton href="/docs/quick-start/install" variant="ghost" className="flex-1">
                Install Guide <ArrowRight size={14} />
              </LinkButton>
            </div>
          </Card>
        </motion.div>
      </section>
    </main>
  );
}
